import { getEnvConfig } from 'utils/getEnvConfig'
import {
  apiRequestInterceptor,
  apiResponseErrorInterceptor,
  apiResponseSuccessInterceptor,
  businessIdInterceptor
} from './apiInterceptor'
import ApiService from './ApiService'
const MERCHANT_HELP_ENDPOINT = '/v1.0/help'

const headers = {
  'content-type': 'application/json',
  accept: 'application/json, text/plain, */*'
}

const endpoint = `${getEnvConfig('WEB_BASE_URL')}/support`

const api = new ApiService(endpoint, headers)
const apiV2 = new ApiService(endpoint.replace('v1', 'v2'), headers)

api.requestInterceptor(apiRequestInterceptor, (error: any) => console.error(error))
api.requestInterceptor(businessIdInterceptor, (error: any) => console.error(error))
api.responseInterceptor(apiResponseSuccessInterceptor, apiResponseErrorInterceptor)

apiV2.requestInterceptor(apiRequestInterceptor, (error: any) => console.error(error))
apiV2.responseInterceptor(apiResponseSuccessInterceptor, apiResponseErrorInterceptor)

export const getHelpSection = (merchantId: string) => {
  return api.getRequest(`${MERCHANT_HELP_ENDPOINT}?merchant_id=${merchantId}`, {})
}

export const MerchantHelpApi = {
  getHelpSection
}
